import { generatePath } from 'react-router-dom'
import {
  MANUFACTURERS,
  MANUFACTURER_UPDATE,
  MANUFACTURER_CREATE,
} from 'constants/api-paths'
import request from './request'
import { formatError } from './error'

export const requestManufacturers = async () => {
  const response = await request.get(MANUFACTURERS)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))

  return response
}

export const requestManufacturerUpdate = async (id, params) => {
  const path = generatePath(MANUFACTURER_UPDATE, { id })
  const response = await request.patch(path, params)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))

  return response
}

export const requestManufacturerCreate = async (params) => {
  const response = await request.post(MANUFACTURER_CREATE, params)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))

  return response
}
